import { cn } from '@/src/helpers';
import { Text } from '@/src/ui-components';
import { FC, HTMLAttributes } from 'react';
import { tradingSectionClasses } from '../trading-section.constants';

export type TradingSectionTitleProps = HTMLAttributes<HTMLHeadingElement>;

export const TradingSectionTitle: FC<TradingSectionTitleProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Text
      className={cn(
        tradingSectionClasses.title,
        className,
        'word-break-word flex items-center gap-2'
      )}
      style={{ margin: 0 }}
      {...rest}
      size="sm"
      as="h2"
      weight="medium"
    >
      {children}
    </Text>
  );
};

//       <Text as="h2" size="sm" weight="medium" className="m-2">
